import { Play } from "lucide-react";
import moment from "moment-timezone";
import Image from "next/image";
import Link from "next/link";

export default function CategoryNewsCard({
  image,
  title,
  imageAlt,
  desc,
  time,
  href = "#",
  isVideo,
  media_details,
}) {
  // const srcSet = media_details
  //   ? Object.values(media_details)
  //       .filter((item) => item?.width && item?.source_url)
  //       .sort((a, b) => a.width - b.width)
  //       .map((item) => `${item.source_url} ${item.width}w`)
  //       .join(", ")
  //   : "";
  return (
    <Link href={href} className="block border-b pb-4">
      {/* MOBILE VIEW */}
      <div className="block md:hidden">
        {/* IMAGE + OVERLAY */}
        <div className="relative w-full">
          <Image
            src={image}
            width={469}
            height={265}
            alt={imageAlt}
            sizes="(max-width:768px) 100vw, 236px"
            className="rounded"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />

          {isVideo && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[60px] h-[60px] bg-black/60 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-white fill-white stroke-none" />
              </div>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="flex flex-col justify-end py-4">
          <h2 className="font-semibold text-[20px] leading-[22px] mb-1">
            {title}
          </h2>

          <p className="text-gray-600 text-sm leading-[23px] mb-2 line-clamp-4">
            {desc}
          </p>

          <div className="text-black text-[11px]">
            <span>Updated: </span>
            <time dateTime={time}>
              {moment(time).tz("Asia/Kolkata").format("MMM D, YYYY h:mm A")}
            </time>
          </div>
        </div>
      </div>

      {/* DESKTOP VIEW */}
      <div className="hidden md:flex gap-4">
        <div className="relative flex-shrink-0">
          <Image
            src={image}
            // srcSet={srcSet}
            sizes="(max-width:768px) 100vw, 236px"
            alt={title}
            width={216}
            height={144}
            className=" object-cover rounded"
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />

          {isVideo && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[50px] h-[50px] bg-black/60 rounded-full flex items-center justify-center">
                <Play className="w-8 h-8 text-white fill-white stroke-none" />
              </div>
            </div>
          )}
        </div>

        {/* CONTENT */}
        <div className="flex-1">
          <h2 className="font-semibold text-[20px] leading-[22px] mb-1">
            {title}
          </h2>

          <p className="text-gray-600 text-sm mb-2 text-[15px] leading-[23px] line-clamp-4">
            {desc}
          </p>

          <div className="text-black text-[11px]">
            <span>Updated: </span>
            <time dateTime={time}>
              {moment(time).tz("Asia/Kolkata").format("MMM D, YYYY h:mm A")}
            </time>
          </div>
        </div>
      </div>
    </Link>
  );
}
